import React from "react";

import ProcessContext from "./context";

export function useProcessActions() {
  const { actions } = React.useContext(ProcessContext);

  return actions;
}

export function useProcessState() {
  const { state } = React.useContext(ProcessContext);

  return state;
}

export function useProcessContext() {
  const { getContext } = React.useContext(ProcessContext);

  return getContext;
}
